import { render, staticRenderFns } from "./AnswerQuestionsPage.vue?vue&type=template&id=4bdc32e0"
import script from "./AnswerQuestionsPage.vue?vue&type=script&lang=js"
export * from "./AnswerQuestionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports